module.exports = __webpack_public_path__ + "static/nxrt-automotive8-171b9a2253cffea30cf4a2176e83a8a1.jpg";